export default "__VITE_ASSET__DOqu3Md6__"